module.exports = __webpack_public_path__ + "img/pay-success-ali.5c5edb1a.png";